export const TOPIC_STYLES = {
  Stoicism: { color: "#c2410c", label: "STOICISM" },
  Fitness: { color: "#b45309", label: "FITNESS" },
  Health: { color: "#4d7c0f", label: "HEALTH" },
  Mindset: { color: "#0e7490", label: "MINDSET" },
  Financial: { color: "#a16207", label: "FINANCIAL" },
  Success: { color: "#b91c1c", label: "SUCCESS" },
  Discipline: { color: "#78716c", label: "DISCIPLINE" },
  Default: { color: "#c2410c", label: "WISDOM" },
};

export const topicStyle = (topic) => TOPIC_STYLES[topic] || TOPIC_STYLES.Default;

export const STONE_TEXTURE =
  "https://images.unsplash.com/photo-1690983320828-c01b88baacb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxkYXJrJTIwc3RvbmUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NzEyMzQ3Nnww&ixlib=rb-4.1.0&q=85";

export const STOIC_STATUE =
  "https://images.pexels.com/photos/11003040/pexels-photo-11003040.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
